<wl-progressive-form-step-card
  [title]="title"
  [subtitle]="subtitle"
  [formStepId]="formStepId"
  [isValid]="false"
  [isSubmitted]="isSubmitted$ | async"
  (setEditingFormStep)="setEditingFormStep()"
  [changeButtonText]="'Change' | translate"
  [canBeEdited]="false"
  [isSkipped]="isSkipped$ | async"
  [isActive]="isCurrentFormStep$ | async"
  [isFutureStep]="isFutureFormStep$ | async"
  [showWhenFutureStep]="showWhenFutureStep"
  [showWhenSkipped]="showWhenSkipped"
  [showSeperator]="true"
  [currentStep]="currentStepIndex$ | async"
  [totalSteps]="totalSteps$ | async"
>
  <div [ngbCollapse]="(isCurrentFormStep$ | async) === false">
    <!-- The collapse only hides the form visually. The tracking should only be rendered when the form is active -->
    @if (currentStepIndex$ | async; as currentStepIndex) {
      @if (isCurrentFormStep$ | async) {
        <div
          [wlTrackStep]="{
            rendering: rendering,
            step: stepNumber ?? currentStepIndex,
            stepName: stepName,
          }"
        ></div>
      }
    }
    @if (formBody) {
      <ng-container [ngTemplateOutlet]="formBody.templateRef"></ng-container>
    }
    @if (showSubmitButton) {
      <wl-progressive-form-submit-button
        [submitButtonAutomationId]="submitButtonAutomationId"
        [submitButtonText]="submitButtonText"
        [submitButtonIcon]="submitButtonIcon"
        [submitButtonLoading]="submitButtonLoading"
        (submitProgessiveForm)="submitForm()"
      ></wl-progressive-form-submit-button>
    }
  </div>

  <!-- Collapse the summary if this is the current visible form step -->
  @if ((isInExperienceEditor$ | async) === false && formSummary) {
    <div [ngbCollapse]="isCurrentFormStep$ | async">
      <ng-container [ngTemplateOutlet]="formSummary.templateRef"></ng-container>
    </div>
  }
</wl-progressive-form-step-card>
